module.exports = __webpack_public_path__ + "static/media/network.5b563319.png";